export default __webpack_public_path__ + "static/media/amity_logo.5e7cfc53.svg";